import React, { useEffect, useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const translationKeys = {
  EMAIL_ADDRESS: "Email Address",
  EMAIL_US: "Email Us",
  PHONE_NUMBER: "Phone Number",
  CALL_US: "Call Us",
  OFFICE_ADDRESS: "Office Address",
  DIRECTION: "Direction",
  SOCIAL_CONNECT: "Social Connect",
};

const ContactArea = () => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        try {
          const translated = await translateContent(translationKeys[key]);
          newTranslations[key] = translated || translationKeys[key];
        } catch {
          newTranslations[key] = translationKeys[key];
        }
      });
      await Promise.all(translationPromises);
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  return (
    <>
      <section
        className="contact__area pt-120 pb-80"
        style={{
          background: `url(assets/img/bg/contact-bg.png)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="contact__item text-center mb-30">
                <div className="contact__icon mb-35">
                  <i className="fas fa-envelope"></i>
                </div>
                <h5 className="contact__title mb-25">
                  {translations.EMAIL_ADDRESS}
                </h5>
                <div className="contact__text">
                  <p>
                    <a href="mailto:info@eaglevizion.com">info@eaglevizion.com</a>
                  </p>
                </div>
                <div className="contact__button mt-30">
                  <a
                    href="mailto:info@eaglevizion.com"
                    className="tp-btn-white"
                  >
                    {translations.EMAIL_US}{" "}
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="contact__item text-center mb-30">
                <div className="contact__icon mb-35">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <h5 className="contact__title mb-25">
                  {translations.PHONE_NUMBER}
                </h5>
                <div className="contact__text">
                  <p>
                    <a href="tel:+1 833 273-2453">+1 833 273-2453</a>
                  </p>
                </div>
                <div className="contact__button mt-30">
                  <a href="tel:+1 833 273-2453" className="tp-btn-white">
                    {translations.CALL_US} <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="contact__item text-center mb-30">
                <div className="contact__icon mb-35">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <h5 className="contact__title mb-25">
                  {translations.OFFICE_ADDRESS}
                </h5>
                <div className="contact__text">
                  <p>
                    <a
                    href="https://www.google.com/maps/place/3995+Rue+Lesage,+Sherbrooke,+QC+J1L+2Z9,+Canada/@45.3970138,-71.9638643,792m/data=!3m2!1e3!4b1!4m6!3m5!1s0x4cb7b4c753aab3c3:0x1a6662a1c84826d1!8m2!3d45.3970101!4d-71.9612894!16s%2Fg%2F11c2d5xr5l?entry=ttu&g_ep=EgoyMDI1MDkyMy4wIKXMDSoASAFQAw%3D%3D"
                      target="blank"
                      rel="noopener noreferrer"
                    >
                      3995 Lesage
                      <br />
                      Sherbrooke (Quebec) J1L 2Z9 Canada
                    </a>
                  </p>
                </div>
                <div className="contact__button mt-30">
                  <a
                    href="https://www.google.com/maps/place/3995+Rue+Lesage,+Sherbrooke,+QC+J1L+2Z9,+Canada/@45.3970138,-71.9638643,792m/data=!3m2!1e3!4b1!4m6!3m5!1s0x4cb7b4c753aab3c3:0x1a6662a1c84826d1!8m2!3d45.3970101!4d-71.9612894!16s%2Fg%2F11c2d5xr5l?entry=ttu&g_ep=EgoyMDI1MDkyMy4wIKXMDSoASAFQAw%3D%3D"
                    target="blank"
                    rel="noopener noreferrer"
                    className="tp-btn-white"
                  >
                    {translations.DIRECTION}{" "}
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="contact__item text-center mb-30">
                <div className="contact__icon mb-35">
                  <i className="fas fa-bullseye"></i>
                </div>
                <h5 className="contact__title mb-25">
                  {translations.SOCIAL_CONNECT}
                </h5>
                <div className="contact__social mt-30">
                  <a
                    href="https://fr-ca.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://x.com/?lang=fr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/eagle-vizion/?originalSubdomain=fr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@eaglevizion1292"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactArea;